export class ProductUpdatePayload {
  constructor(data) {
    this.name = data.name;
    this.names = data.names;
    this.macroCategory = data.macroProductCategory;
    this.microCategory = data.microProductCategory;
    this.brand = data.brand;
  }
}
